export default __webpack_public_path__ + "static/media/BackgroundPhotoVertical.627df34c.jpg";